/**
 * Service-worker registration (ARCHITECTURE.md §5): register /sw.js (the
 * stable path the cutover interlock depends on), then `registration.update()`
 * on every launch and on visibilitychange — iOS never updates SWs on its own
 * schedule reliably. The build-id change seen in SSE heartbeats also lands
 * here (version-skew kill, ADR-003).
 */
let registration: ServiceWorkerRegistration | null = null;

export async function registerServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  // Vite dev server doesn't build the SW; production only.
  if (import.meta.env.DEV) return;
  try {
    registration = await navigator.serviceWorker.register("/sw.js");
    void registration.update(); // update check on launch

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") void requestSwUpdate();
    });
  } catch {
    // SW is progressive enhancement: the app still works online without it.
  }
}

/** Explicit update check — called on visibility and on heartbeat build change. */
export async function requestSwUpdate(): Promise<void> {
  try {
    await registration?.update();
  } catch {
    /* offline update checks fail — fine */
  }
}
